import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  search: null,
};

const blogFilterSlice = createSlice({
  name: "blogFilter",
  initialState,
  reducers: {
    setBlogStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setBlogSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearBlogFilter: () => ({
      status: null,
      search: null,
    }),
  },
});

export const {
  setBlogStatusFilter,
  setBlogSearchFilter,
  clearBlogFilter,
} = blogFilterSlice.actions;

export const selectBlogFilter = (state) => state.blogFilter;

export default blogFilterSlice.reducer;
